var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 0C13.7275 0 13 0.727537 13 1.625C13 2.52246 13.7275 3.25 14.625 3.25H24.375C25.2725 3.25 26 2.52246 26 1.625C26 0.727537 25.2725 0 24.375 0H14.625Z",
    fill: "#F9A01B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 24.9167C39 35.6862 30.2696 44.4167 19.5 44.4167C8.73045 44.4167 0 35.6862 0 24.9167C0 14.1471 8.73045 5.41667 19.5 5.41667C30.2696 5.41667 39 14.1471 39 24.9167ZM11.851 19.5657C11.2164 18.9311 11.2164 17.9022 11.851 17.2676C12.4856 16.633 13.5144 16.633 14.149 17.2676L20.6491 23.7676C21.2837 24.4022 21.2837 25.4311 20.6491 26.0657C20.0144 26.7003 18.9856 26.7003 18.351 26.0657L11.851 19.5657Z",
    fill: "#F9A01B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingTransaction);
export default __webpack_public_path__ + "static/media/pending-transaction.296fbe2558f3e41e38b5d0dd73076dc5.svg";
export { ForwardRef as ReactComponent };